import * as React from "react";
import { Button, Dropdown, MenuProps, Space } from "antd";
import { DownOutlined, SisternodeOutlined } from "@ant-design/icons";
import { GroupType } from "src/types/ZGroup";
import {
  TreeActionsPort,
  TreeDataPort,
} from "src/pages/ManagementPage/objects/ports";
import { ValueO2 } from "../../Obj2Nodes";
import { AddExistingAttribute } from "../AddExistingAttribute";
import { getGroupTypeIcon } from "../../utils/itemIcons";

interface PropsAddValueItem {
  store: TreeActionsPort & TreeDataPort;
  valueNode: ValueO2;
  disabled?: boolean;
  buttonId?: string;
}

export const AddValueItem: React.FC<PropsAddValueItem> = (props) => {
  const { store, disabled, buttonId, valueNode } = props;

  const menuProps: MenuProps = {
    items: [
      {
        key: "attr",
        label: "Добавить атрибут",
        icon: <SisternodeOutlined />,
        onClick: () => store.safeAddAttr(),
        disabled,
      },
      {
        key: "existingAttr",
        label: <AddExistingAttribute store={store} valueNode={valueNode} />,
      },
      {
        type: "divider",
      },
      {
        key: "groups",
        type: "group",
        label: "Добавить группу атрибутов",
        children: [
          {
            key: "mnenoGroup",
            label: "Мнемоническую",
            icon: getGroupTypeIcon(GroupType.Mnemonic),
            onClick: () => store.safeAddGroup(GroupType.Mnemonic),
            disabled,
          },
          {
            key: "dictiGroup",
            label: "На основе справочника",
            icon: getGroupTypeIcon(GroupType.ByDictionary),
            onClick: () => store.safeAddGroup(GroupType.ByDictionary),
            disabled,
          },
        ],
      },
    ],
  };

  return (
    <Dropdown menu={menuProps}>
      <Button id={buttonId}>
        <Space>
          Добавить
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};
